import html from './uploadComponent.html';
import './uploadComponent.css';
import { ensure } from 'components/sharpr/ensure/ensure';
import { easyCrypto } from 'components/sharpr/easyCrypto/easyCrypto';
import { googleOauth } from '../../../../a-react-app/src/_common/libs/google/googleOauth.js';
import { googleDrive } from '../../../../a-react-app/src/_common/libs/google/googleDrive.js';
import moment from 'moment';
import { plupload } from '../../../../a-react-app/src/_common/libs/pluploadLite/plupload';
import RunQueue from 'run-queue';

export function uploadComponent() {
	return {
		bindings: {
			files: '=?',
			state: '=?',
			percent: '=?',
			onAdd: '&?',
			onUpload: '&?',
			onRemove: '&?',
			onError: '&?',
			createAttachment: '<?',
			multiSelection: '<?',
			allowedExtensions: '<?',
			allowDuplicates: '<?',
			dragText: '@?',
			browseText: '@?',
			browseTextMulti: '@?',
			spaceOutMs: '<?',
		},
		controllerAs: 'vm',
		controller: uploadComponentCtrl,
		template: html,
	};
}

let s3Config;
let s3ConfigPromise;

export class uploadComponentCtrl {
	constructor($timeout, $element, Api, modal, Cfg, EventTracker, Identity) {
		'ngInject';
		this.$timeout = $timeout;
		this.$element = $element;
		this.Api = Api;
		this.modal = modal;
		this.Cfg = Cfg;
		this.EventTracker = EventTracker;
		this.Identity = Identity;
	}

	$onInit() {
		this.dragText = this.dragText || 'Drag & drop or';
		this.browseText = this.browseText || 'choose file';
		this.browseTextMulti = this.browseTextMulti || 'choose files';
		this.state = 'idle';
		this.uploadOrder = this.Cfg.read('Ui.attachment_upload_order') || 'oldest-first';
		this.error = '';
		this.allowedExtensions = this.allowedExtensions || [];

		this._fetchAllowedExtensions()
			.then(extensions => {
				this.allowedExtensions = extensions;

				return extensions;
			})
			.then(this.loadS3Config.bind(this))
			.then(this.setupPluploader.bind(this))
			.catch(() => {
				this.error =
					'We are having trouble setting up file uploading. Please try again later, or contact us if you continue to see this message.';
			});
	}

	$onDestroy() {
		try {
			this.pluploader.destroy();
		} catch (e) {
			console.error('Error destroying uploader');
		}

		clearTimeout(this.newConfigPromiseTimeout);
	}

	getOptions() {
		const dropEl = this.$element[0].querySelector('.su-droppable');
		const browseEl = this.$element[0].querySelector('.su-browse-button');
		return {
			drop_element: dropEl,
			browse_button: browseEl,
			multi_selection: !!this.multiSelection,
			url: 'https://' + this.s3.bucket + '.s3.amazonaws.com/',
			multipart_params: {
				key: '${filename}', // use filename as a key
				Filename: '${filename}', // adding this to keep consistency across the runtimes
				acl: 'public-read',
				'Content-Type': 'application/octet-stream',
				policy: this.s3.policy,
				'x-amz-algorithm': 'AWS4-HMAC-SHA256',
				'x-amz-credential': this.s3.xAmzCredential,
				'x-amz-date': this.s3.isoDate,
				'x-amz-signature': this.s3.signature,
				'x-amz-server-side-encryption': 'AES256',
				'x-amz-security-token': this.s3.securityToken,
			},
			file_data_name: 'file',
			filters: {
				prevent_duplicates: !this.allowDuplicates,
				max_file_size: this.s3.maxFileSize,
				allowed_extensions: this.allowedExtensions,
			},
		};
	}

	loadS3Config() {
		if (!s3ConfigPromise) {
			if (s3Config) {
				s3ConfigPromise = Promise.resolve(s3Config);
			} else {
				s3ConfigPromise = this.Api.get('/uploads/config');
			}
			this.newConfigPromiseTimeout = setTimeout(
				() => {
					// fetch new config FOR THIS component before it expires
					s3Config = null;
					s3ConfigPromise = null;
					this.loadS3Config().then(() => {
						this.pluploader.setOption(this.getOptions());
					});
				},
				24 * 60 * 60 * 1000
			);
		}
		return s3ConfigPromise.then(s3 => {
			s3Config = s3;
			setTimeout(
				() => {
					// expire config cache ACROSS ALL components
					s3Config = null;
				},
				24 * 60 * 60 * 1000
			);
			this.s3 = s3;
			this.$timeout(() => {});
		});
	}

	setupPluploader() {
		this.inProgress = [];
		this.pluploader = new plupload.Uploader(this.getOptions());
		this.pluploader.init();
		this.setupPluploaderEvents();

		this.$timeout(() => {});
	}

	setupPluploaderEvents() {
		this.pluploader.bind('BeforeUpload', this._handleBeforeUpload.bind(this));
		this.pluploader.bind('FilesAdded', this._handleFilesAdded.bind(this));
		this.pluploader.bind('UploadProgress', this._handleUploadProgress.bind(this));
		this.pluploader.bind('FileUploaded', this._handleFileUploaded.bind(this));
		this.pluploader.bind('Error', this._handlePluploaError.bind(this));
	}

	_fetchAllowedExtensions() {
		return this.Api.get('/config/supported_file_extensions', null, { cacheFor: 24 * 60 * 60 * 1000 })
			.then(validExtensions => {
				if (this.allowedExtensions.length > 0) {
					return this.allowedExtensions.filter(e => validExtensions.includes(e));
				} else {
					return validExtensions;
				}
			})
			.catch(err => {
				console.error('Error fetching allowed extensions', err.message);

				return [];
			});
	}

	_setFileMetadata(up, file) {
		// specify a custom filename
		const randomName = Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
		const extension = file.name && file.name.indexOf('.') > -1 ? file.name.split('.').pop() : '';
		const Ymd = moment().format('YYYY-MM-DD');
		// use an S3 path of date/randomstring so we can easily delete old files from s3
		file.s3Basename = randomName + (extension ? '.' + extension : '');
		file.s3Name = Ymd + '/' + file.s3Basename;
		file.s3Url = up.settings.url + file.s3Name;
		file.extension = extension;
		file.cancel = () => this.pluploader.removeFile(file);
		up.settings.multipart_params.key = up.settings.multipart_params.Filename = file.s3Name;
		this._promptAndTranscribe(file);
	}

	/**
	 * This only handles "native" Google Drive files like Docs, Sheets, Slides, etc. Other files from the Google Drive
	 * app are sent through the existing file flow. Steps completed:
	 * 1. Get OAuth credentials (and send through OAuth process if necessary)
	 * 2. Create a browser File object from the uploaded Google file
	 * 3. Adds the file to the list of files to be processed
	 * @param googleFileDetails Object  See `googleDrive.getNativeFile` for params
	 * @returns {Promise<unknown>}
	 */
	async handleGoogleDriveFile(googleFileDetails) {
		console.log('Turn on Debug-level logs in the dev console to see information about the Google Drive process.');
		return new Promise(async (resolve, reject) => {
			console.group('Google OAuth debug information:');
			console.debug('checking for oauth_credentials...');
			const user = this.Identity.user();
			const data = await googleOauth.getUserToken(user.id);
			let creds = await data.json();

			console.debug('oauth_credentials result:', creds);

			// no valid token. Get a token then continue with getting the file.
			if (creds.status === 404) {
				let error;
				this.modal
					.html({
						text: 'Requesting permission to access this file on Google Drive...',
						heading: 'One Moment',
						width: 300,
						height: 200,
					})
					.catch(e => {
						// I think this happens because it is trying to close the modal after it's closed?
						console.debug('Modal issue, but it probably did not cause any problems', e);
					});
				// waiting here for a bit so the user has time to read the message
				await new Promise(resolve =>
					setTimeout(() => {
						// clear the notification
						this.modal.closeAll('One Moment');
						resolve();
					}, 3000)
				);
				const tokenResult = await googleOauth
					.getAndSaveToken(user.email, 'https://www.googleapis.com/auth/drive.readonly')
					.catch(e => {
						error = e.message;
					});
				if (error) {
					this.error = error;
					this.$timeout(() => {});
					return;
				}
				creds.payload = { token: tokenResult.token };
			}
			console.groupEnd();

			console.group('Google Drive debug information:');
			const nativeFileResult = await googleDrive.getNativeFile(googleFileDetails, creds.payload.token);
			console.debug('nativeFileResult', nativeFileResult);
			if (nativeFileResult.success === true) {
				console.groupEnd();
				resolve(nativeFileResult.nativeFile);
			} else {
				this.error = 'Error importing Google Drive file. ' + nativeFileResult.message;
				console.groupEnd();
				resolve(nativeFileResult);
				this.$timeout(() => {});
			}
		});
	}

	_handleBeforeUpload(up, file) {
		// update our state
		this.state = 'uploading';
		// set custom property and s3 header values
		this._setFileMetadata(up, file);

		this.$timeout(() => {});
	}

	async _handleFilesAdded(up, files) {
		if (!this.multiSelection) {
			// clear out the files array
			this.files.length = 0;
		}
		this.error = '';
		for (const file of files) {
			const fileDetails = await googleDrive.isGoogleDriveFile(file);
			if (fileDetails.is_gdrive) {
				this.state = 'uploading-gdrive';
				this.$timeout(() => {});

				const nativeFileObject = await this.handleGoogleDriveFile(fileDetails);
				if (nativeFileObject.success === false) {
					// move on. `handleGoogleDriveFile has notified the user this file failed.
					return;
				}
				// overwriting props on `file` because the current props refer to the json file from the Google Drive app
				file._nativeFile = nativeFileObject;
				file.name = nativeFileObject.name;
				file.fullPath = '/' + nativeFileObject.name;
				file.size = nativeFileObject.size;
				file.origSize = nativeFileObject.size;
				file.sourceLink = fileDetails.gdrive_url || nativeFileObject.gdrive_url || null;
			}
			this.categorize(file);
			const add = this.uploadOrder === 'newest-first' ? 'unshift' : 'push';
			this.inProgress[add](file);
		}
		up.start();
		this.$timeout(() => {});
	}

	_handleUploadProgress(up, file) {
		let loaded = 0;
		let total = 0;
		this.inProgress.forEach(file => {
			loaded += file.loaded || 0;
			total += file.total || 0;
		});
		this.percent = total > 0 ? Math.round((100 * loaded) / total) : 0;
		this.$timeout(() => {});
	}

	_createAttachment(file) {
		if (!this.queue || this.queue.finished) {
			this.queue = new RunQueue({ maxConcurrency: 1 });
		}
		const create = sha256 => {
			if (file.wasAborted || file.isDeleted) {
				return Promise.resolve();
			}
			const params = {
				cloud_file_bucket: this.s3.bucket,
				cloud_file_key: file.s3Name,
				name: file.name,
				size: file.size,
				sha256,
				allow_duplicates: this.allowDuplicates,
				folders: ensure.array(file.dirs),
				transcribe: file.transcribe || false,
				external_ref: file._nativeFile.externalRef || null,
			};
			return this.Api.post(`/attachments`, params, { avoidLoadingBar: true }).then(report => {
				file.attId = report.attachment_id;
				file.duplicates = report.duplicate_files;
				file.sha256 = sha256;
				file.cloud_file_bucket = this.s3.bucket;
				if (file.transcribe && !params.transcribe) {
					// I was hitting a race condition between confirming duplicate uploads, saying to transcribe,
					// creating the attachment, and starting transcription. I'm trying to catch those with this call.
					this.Api.post(`/attachments/${file.attId}/transcribe`, {
						s3_name: file.s3Name,
					});
				}
				return file.attId;
			});
		};
		this.queue.add(1, () => {
			return this._getSha256(file).then(sha256 => {
				if (this.spaceOutMs) {
					return new Promise((resolve, reject) => {
						create(sha256).then(() => {
							setTimeout(resolve, this.spaceOutMs);
						}, reject);
					});
				}
				return create(sha256);
			});
		});
		return this.queue.run();
	}

	/**
	 * Get the sha256 digest of the contents of the given file
	 * @param {Object} file  The file object from the uploader
	 * @return {Promise<String>}
	 * @private
	 */
	_getSha256(file) {
		if (!window.crypto || !window.crypto.subtle) {
			// browser crypto is not supported; we can't get sha256
			// could be old browser or a non-https connection
			return Promise.resolve(this._getRandomHex('0'));
		}
		if (file.size > 25 * 1024 * 1024) {
			// file is too big; sha256 may cause browser to crash
			// as of Mar 2019, 96% of all files are under 25MB
			return Promise.resolve(this._getRandomHex('1'));
		}
		// otherwise calculate sha256 digest
		return easyCrypto.sha256(file.getNative());
	}

	/**
	 * Get a random hex string to be used as a stand-in for a sha256 digest
	 * @param {String} prefixChar  The number to use as the first 8 characters
	 * @return {String}
	 * @private
	 */
	_getRandomHex(prefixChar) {
		// prefix with eight 0s or 1s so that we can identify later if needed
		let hex = new Array(9).join(prefixChar);
		// then add 56 random hex characters
		for (let i = 0; i < 56; i++) {
			hex += Math.floor(Math.random() * 16).toString(16);
		}
		return hex;
	}

	_handleFileUploaded(up, file) {
		const afterUpload = () => {
			this.removeInProgressFile(file);
			file.listItem = {
				id: file.attId,
				icon: file.icon,
				name: file.name,
				href: file.s3Url,
				size: file.size,
			};
			const add = this.uploadOrder === 'newest-first' ? 'unshift' : 'push';
			this.files[add](file.listItem);
			this.state = 'waiting';
			if (this.onUpload) {
				this.onUpload({ $file: file });
			}
			this.$timeout(() => {});
		};

		if (this.createAttachment) {
			this._createAttachment(file).then(afterUpload);
		} else {
			afterUpload();
		}
	}

	removeUploadedFile(file) {
		const idx = this.files.indexOf(file);
		if (idx > -1) {
			this.files.splice(idx, 1);
			if (this.onRemove) {
				this.onRemove({ $file: file });
				this.$timeout(() => {});
			}
		}
	}

	removeInProgressFile(file) {
		const idx = this.inProgress.indexOf(file);
		if (idx > -1) {
			this.inProgress.splice(idx, 1);
		}
		this.pluploader.removeFile(file);
	}

	cancelAll() {
		this.pluploader.stop();
		this.state = 'idle';
		this.inProgress.length = 0;
	}

	categorize(file) {
		const types = [
			{
				icon: 'icon-file-word',
				category: 'doc',
				exts: 'doc,docx,docm,dot,dotm,rtf'.split(','),
			},
			{
				icon: 'icon-image',
				category: 'image',
				exts: 'jpg,jpeg,png,gif,svg,bmp,tiff,psd,ai,eps,ps'.split(','),
			},
			{ icon: 'icon-file-pdf', category: 'pdf', exts: 'pdf'.split(',') },
			{
				icon: 'icon-file-powerpoint',
				category: 'ppt',
				exts: 'ppt,pptm,pptx,pps,ppsm,ppsx,pot,potx'.split(','),
			},
			{
				icon: 'icon-movie',
				category: 'video',
				exts: '3g2,3gp,3gpp,asf,asx,avi,flv,mov,mp4,m4v,mkv,mpeg,mpg,ogv,qt,rm,vob,webm,wmv'.split(','),
			},
			{ icon: 'icon-audio', category: 'audio', exts: 'wav,mp3,flac'.split(',') },
			{
				icon: 'icon-file-excel',
				category: 'xls',
				exts: 'csv,xl,xls,xlsx,xlt,xltx'.split(','),
			},
			{
				icon: 'icon-file-zip',
				category: 'zip',
				exts: 'zip,7z,cab,rar,tar,gz,tgz,bz2'.split(','),
			},
			{ icon: 'icon-file-empty', category: 'exe', exts: 'exe,msi,dmg,pkg'.split(',') },
		];
		let matchingType = { icon: 'icon-file', category: 'other' }; // default
		const ext = ensure.string(file.name).split('.').pop().toLowerCase();
		types.some(type => {
			if (type.exts.indexOf(ext) > -1) {
				matchingType = type;
				return true;
			}
		});
		file.icon = matchingType.icon;
		file.category = matchingType.category;
	}

	_handlePluploaError(up, error) {
		const messages = {
			POLICY_EXPIRED: 'The page has expired. Please refresh the page and try again.',
			GENERIC: 'Unknown error. Please try again',
			HTTP: 'Your computer is having trouble transmitting that file. Please try again.',
			IO: 'Your browser is having trouble reading that file. Please try again.',
			SECURITY: 'Your browser does not have permision to upload that file. Please try a different file.',
			INIT: 'Error: image uploader is temporarily unavailable',
			FILE_SIZE: `Error: files can be no larger than ${this.s3.maxFileSize}.`,
			FILE_EXTENSION: 'Error: file type not allowed.',
			FILE_DUPLICATE: 'Error: that file was already added.',
			IMAGE_FORMAT: 'Error: invalid image file.',
			MEMORY: 'Memory exhausted. Please try a smaller file.',
			IMAGE_DIMENSIONS: 'Error: image was too big. Please try a smaller image.',
		};

		let msg = error.message;

		if (/policy expired/i.test(error.response)) {
			msg = msg || messages.POLICY_EXPIRED;
		}

		for (var code in messages) {
			if (plupload[code + '_ERROR'] === error.code) {
				msg = msg || messages[code];
				break;
			}
		}

		error.file.error = msg;

		if (this.onError) {
			this.onError({
				$file: error.file,
				$error: error,
				$message: msg,
				$header: 'Unsupported File',
			});
			this.$timeout(() => {});
		} else {
			this.error = msg;

			this.$timeout(() => {});
		}
	}

	_promptAndTranscribe(file) {
		const setting = this.Cfg.read('AI.transcribe_videos');
		if ((file.category === 'video' || file.category === 'audio') && setting && setting !== 'none') {
			this.modal
				.confirm({
					escapedHtml: `
						Would you like your ${file.category} file "${file.name}" to be transcribed
						using our A.I. powered transcription service?<br>
						Audio must be in English.
						${setting === 'medical' ? 'Medical vocabulary is supported.' : ''}
					`,
					confirmText: 'YES',
					cancelText: 'NO',
					heading: 'Video Transcription', // this heading is used to close these modals if the upload is cancelled
					width: 400,
				})
				.then(result => {
					// file.attId if attachment has been created
					if (!file.attId) {
						file.transcribe = true;
					} else {
						this.Api.post(`/attachments/${file.attId}/transcribe`, {
							s3_name: file.s3Name,
						});
					}
					this.modal
						.state('hub.loggedin.VideoTranscriptionUserPrompt', {
							heading: 'Thank you',
							width: 400,
							height: 175,
						})
						.then(() => {})
						.catch(() => {});
				})
				.catch(() => {
					// user said no or clicked X; don't transcribe
					file.transcribe = false;
				});
		}
	}
}
